import { render } from "./SelectGroup.vue?vue&type=template&id=2df85e20&scoped=true"
import script from "./SelectGroup.vue?vue&type=script&lang=js"
export * from "./SelectGroup.vue?vue&type=script&lang=js"

import "./SelectGroup.vue?vue&type=style&index=0&id=2df85e20&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df85e20"]])

export default __exports__